import { render, staticRenderFns } from "./TVShow3.vue?vue&type=template&id=8a62a384&scoped=true&"
import script from "./TVShow3.vue?vue&type=script&lang=js&"
export * from "./TVShow3.vue?vue&type=script&lang=js&"
import style0 from "./TVShow3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TVShow3.vue?vue&type=style&index=1&id=8a62a384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a62a384",
  null
  
)

export default component.exports